import { createSlice } from "@reduxjs/toolkit";

export const jobSlice = createSlice({
  name: "job",
  initialState: {
    list: [],
    number: 1,
    jobfair_list: [],
  },
  reducers: {
    setJob: (state, action) => {
      console.log("setJob", action.payload);
      state.list = action.payload.list;
    },
    setNumber: (state, action) => {
      console.log("setNumber", action.payload);
      state.number = action.payload.number;
    },
    setJobfairList: (state, action) => {
      console.log("setJobfairList", action.payload);
      state.jobfair_list = action.payload.jobfair_list;
    },
  },
});

export const { setJob, setNumber, setJobfairList } = jobSlice.actions;

export default jobSlice.reducer;
